import {connect} from 'pwa-helpers';
import {css, LitElement} from 'lit';
import {property} from 'lit/decorators/property.js';

import store from '../../store';
import {decision, decisions, fetchConsequences, fetchDecisions} from '../../slices/decisionsSlice';
import {pimText} from '../../util/values';
import {mergeWithProperty} from '../../util/mergeWithProperty';
import {setExplainActive} from '../../slices/statusSlice';


export class FeatureSelectItem extends connect(store)(LitElement) {

	static styles = css`
	  .hoverinfo {
		transition: left 0.25s ease-out, opacity 0.25s ease-out;
		transform: translateY(-50%);
		display: block;
		opacity: 0;
		pointer-events: none;
		position: absolute;
		top: 18px;
		left: calc(100% + 25px);
		z-index: 10;
		margin: 0 auto;
		width: 200px;
	  }
	  .item {
		margin-bottom: 10px;
	  }
	  .values.notSatisfied {
		border: none;
	  }
	  .item button {
		font-family: var(--font-family-monospace);
		font-size: var(	--font-size-widget-small-mono);
		color: var(--color-white);
		background-color: var(--color-background-widget);
		min-height: var(--height-widget);
		transition: background-color 0.4s, color 0.4s;
		padding: 0.5em 1em;
		line-height: 19px;
		margin: 0;
		border: var(--border-widget);
		cursor: pointer;
		width: 100%;
		text-align: left;
	  }
	  /* .item button::before {
		content: '';
		position: absolute;
		right: 15px;
		background-image: url("data:image/svg+xml,%3Csvg width='7' height='10' viewBox='0 0 7 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.863281 0.570312L5.73828 4.90365L0.863282 9.30365' stroke='white' stroke-width='0.5' stroke-linecap='square'/%3E%3C/svg%3E%0A");
		width: 10px;
		height: 20px;
		background-repeat: no-repeat;
		background-position-y: center;
	}
	 .selected button::before {
		background-image: url("data:image/svg+xml,%3Csvg width='7' height='10' viewBox='0 0 7 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.863281 0.570312L5.73828 4.90365L0.863282 9.30365' stroke='black' stroke-width='0.5' stroke-linecap='square'/%3E%3C/svg%3E%0A");
		width: 10px;
		height: 20px;
		background-repeat: no-repeat;
		background-position-y: center;
	} commented out becuase not wanted everywhere - to be decided
	*/

	  .item:hover .hoverinfo {
		display: block;
		opacity: 1;
		left: calc(100% + 5px);
		transition-delay: 0.2s;
	  }
	  .hoverinfo .content {
		position: relative;
		border: var(--border-widget);
		padding: 0.5em 1em;
		background-color: var(--color-black);
		font-family: var(--font-family-light);
		color: var(--color-text-widget-value);
		font-size: var(--font-size-widget);
	  }
	  .hoverinfo .content:after {
		content: '';
		position: absolute;
		left: 0;
		top: 50%;
		width: 0;
		height: 0;
		border: 10px solid transparent;
		border-right-color: #000000;
		border-left: 0;
		margin-top: -10px;
		margin-left: -10px;
	  }
	  .hoverinfo .content:before {
		content: '';
		position: absolute;
		left: 0;
		top: 50%;
		width: 0;
		height: 0;
		border: 12px solid transparent;
		border-right-color: var(--border-widget);
		border-left: 0;
		margin-top: -12px;
		margin-left: -12px;
	  }
	`;

	@property({type: Object})
	feature = {};

	@property({type: Object})
	featureValue = {};

	@property({type: Object})
	productData = {};

	@property({type: String})
	state = 'Undefined';

	@property({type: Boolean})
	hideDisabled = false

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.lang = state.status.lang;
	}

	isIncluded() {
		const key = this.feature.variableId + '.' + this.featureValue.featureValueId;
		return (key in this.decisions.normalizedDecisions && this.decisions.normalizedDecisions[key].isIncluded);
	}

	isExcluded() {
		const key = this.feature.variableId + '.' + this.featureValue.featureValueId;
		return (key in this.decisions.normalizedDecisions && this.decisions.normalizedDecisions[key].isExcluded);
	}

	canBeIncluded() {
		const key = this.feature.variableId + '.' + this.featureValue.featureValueId;
		return (key in this.decisions.normalizedDecisions && this.decisions.normalizedDecisions[key].canBeIncluded);
	}

	canBeExcluded() {
		const key = this.feature.variableId + '.' + this.featureValue.featureValueId;
		return (key in this.decisions.normalizedDecisions && this.decisions.normalizedDecisions[key].canBeExcluded);
	}
	isVisible() {
		return this.hideDisabled ? this.canBeIncluded() : true;
	}
	explanations() {
		const key = this.feature.variableId + '.' + this.featureValue.featureValueId;
		return {
			desiredFeature: {
				variableId: this.feature.variableId,
				featureValueId: this.featureValue.featureValueId
			},
			causes: (key in this.decisions.normalizedExplanations && this.decisions.normalizedExplanations[key].causes)
		};
	}

	hasExplanation() {
		const key = this.feature.variableId + '.' + this.featureValue.featureValueId;
		return (key in this.decisions.normalizedExplanations && this.decisions.normalizedExplanations[key].causes.length > 0);
	}

	async toggleDecision() {
		if ((this.isExcluded && !this.canBeIncluded()) || (this.isIncluded() && !this.canBeExcluded())) {
			if (this.hasExplanation()) {
				store.dispatch(setExplainActive(
					{
						explainActive: true,
						explanations: this.explanations(),
						state: this.isIncluded() ? 'Undefined' : 'Included'
					}
				));
			}
		} else {
			if (!this.isIncluded()) { // no deselection possible
				await store.dispatch(decision(
					{
						variableId: this.feature.variableId,
						featureValueId: this.featureValue.featureValueId,
						state: this.isIncluded() ? 'Undefined' : 'Included'
					}
				)).unwrap();
			}
		}
	}

	getInfoText() {
		return '';
		// TODO: reactivate when data is there
		/*
		const display = pimText(this.lang, this.feature.variableId, 'FV', this.decisions, this.translations, this.featureValue.featureValueId);
		const short = pimText(this.lang, this.feature.variableId, 'FV.S', this.decisions, this.translations, this.featureValue.featureValueId);
		const long = pimText(this.lang, this.feature.variableId, 'FV.L', this.decisions, this.translations, this.featureValue.featureValueId);
		const info = long || short || '';
		return info !== display ? info : '';
		 */
	}

	render() {
	}
}
